import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { getIsAuthenticated } from '../lib/cognitoutils';
import { UserContext } from '../lib/usercontext';

const isAuthenticated = () => {
  return getIsAuthenticated();
};

const ProtectedRoute = ({ children, allowedRoles }) => {
  // const { user } = useContext(UserContext);
  useContext(UserContext);
  
  if (!isAuthenticated()) {
    // Redirect them to the login page, but save the current location they were trying to go to
    return <Navigate to="/login" />;
  }
  
  const role = "admin";

  if (allowedRoles && !allowedRoles.includes(role)) {
    // Redirect to an unauthorized page or dashboard if role is not allowed
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
};


export default ProtectedRoute;
